import { Icons } from "assets";
import classNames from "classnames";
import moment from "moment";
import { useEffect, useId, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import CustomButton from "shared/components/common/customButton";
import Draggable from "shared/components/common/customDraggable";
import CustomToolTip from "shared/components/common/customToolTip";
import NoContentCard from "shared/components/common/noContentCard";
import { toastMessage } from "shared/components/common/toast";
import FilterSideCanvas from "shared/components/filtersSideCanvas";
import DownlaodOptionsDropDown from "shared/dropdowns/downloadOptions";
import useDebounce from "shared/hooks/useDebounce";
import SekeletonLoader from "shared/loaders/skeleton";
import { setBreadCrumb } from "shared/redux/reducers/breadCrumbSlice";
import { routeConstant } from "shared/routes/routeConstant";
import { GetSingleEvaluationVersionsService } from "shared/services/evaluations";
import { exportToExcel } from "shared/services/exportExcel";
import { ColumnHeads, FixedColumns } from "shared/utils/constants";
import { JobRole } from "shared/utils/enum";
import {
  getLeftPosition,
  getTopPosition,
  sortJobsByKey,
} from "shared/utils/helper";
import styles from "./styles.module.scss";
import { GetOrganizationDetailService } from "shared/services/organization";
import Switch from "shared/components/common/switch";

const EvaluationDetail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const params = useParams();
  const [loading, setLoading] = useState<boolean>(true);
  const [evaluations, setEvaluations] = useState<any[]>([]);
  const [search, setSearch] = useState<string>("");
  const [searchVal, setSearchVal] = useState<string>("");
  const [openFilters, setOpenFilters] = useState<boolean>(false);
  const [selectedColumns, setSelectedColumns] = useState<string[]>([]);
  const [sortingKeys, setSortingKeys] = useState<string[]>([]);
  const [filters, setFilters] = useState<any>(null);
  const [openDropdown, setOpenDropdown] = useState<boolean>(false);
  const [selectedItem, setSelectedItem] = useState<any>(null);
  const [initial, setInitial] = useState<boolean>(true);

  const options = [
    {
      title: "Export rows as PDF",
      Icon: null,
      action: () => {},
    },
    {
      title: "Export rows as XLSX/CSV",
      Icon: null,
      action: (data: any) => {
        setOpenDropdown(false);
        exportToExcel(data);
      },
    },
  ];

  const handleGetEvaluations = () => {
    setLoading(true);
    if (params?.id) {
      GetSingleEvaluationVersionsService({
        search: searchVal,
        id: String(params?.id),
        filter: filters,
      })
        .then(({ data }) => {
          setEvaluations(data);
        })
        .catch((err) => {
          toastMessage("error", err?.response?.data?.error);
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      navigate(-1);
    }
  };

  const handleSorting = (key: string, revese = false) => {
    let keys = [...sortingKeys];
    if (keys.includes(key)) {
      keys = keys.filter((item) => item !== key);
    } else {
      keys.push(key);
    }
    setSortingKeys(keys);
    let jobs = [...evaluations];
    sortJobsByKey(jobs, key, revese);
    setEvaluations(jobs);
  };

  const handleGetOrganizationDetail = () => {
    GetOrganizationDetailService(params?.org ? params?.org : "")
      .then(({ data: { data } }) => {
        if (data) {
          dispatch(
            setBreadCrumb({
              crumbs: [
                {
                  title:
                    data?.name +
                    " " +
                    routeConstant.evaluationRecordDetail.title,
                },
              ],
            })
          );
        }
      })
      .catch((err) => {
        toastMessage("error", err?.response?.data?.error);
      });
  };

  useEffect(() => {
    if (openDropdown) {
      const elem: any = document.getElementById(
        `custom-select-container-${selectedItem?.id}`
      );
      const optionsDropDown: any = document.getElementById(`download`);
      if (elem && optionsDropDown) {
        const topPosition = getTopPosition(elem);
        const leftPosition = getLeftPosition(elem);
        optionsDropDown.style.top =
          Number(topPosition + elem?.clientHeight) + "px";
        optionsDropDown.style.left = Number(leftPosition - 178) + "px";
      }
    }

    // eslint-disable-next-line
  }, [openDropdown]);

  useEffect(() => {
    handleGetOrganizationDetail();
    // eslint-disable-next-line
  }, [params?.id]);

  useEffect(() => {
    let filtersObj = {
      startDate:
        queryParams.get("startDate") !== "undefined" &&
        queryParams.get("startDate") !== null
          ? queryParams.get("startDate")
          : null,
      endDate:
        queryParams.get("endDate") !== "undefined" &&
        queryParams.get("endDate") !== null
          ? queryParams.get("endDate")
          : null,
      status:
        queryParams.get("status") !== "undefined" &&
        queryParams.get("status") !== null
          ? queryParams.get("status")
          : null,
      user:
        queryParams.get("user") !== "undefined" &&
        queryParams.get("user") !== null
          ? queryParams.get("user")
          : null,
      jobTitle:
        queryParams.get("jobTitle") !== "undefined" &&
        queryParams.get("jobTitle") !== null
          ? queryParams.get("jobTitle")
          : "",
      department:
        queryParams.get("department") !== "undefined" &&
        queryParams.get("department") !== null
          ? queryParams.get("department")
          : "",
      jobCode:
        queryParams.get("jobCode") !== "undefined" &&
        queryParams.get("jobCode") !== null
          ? queryParams.get("jobCode")
          : "",
      jobGrade:
        queryParams.get("jobGrade") !== "undefined" &&
        queryParams.get("jobGrade") !== null
          ? queryParams.get("jobGrade")
          : "",
      roleType:
        queryParams.get("roleType") !== "undefined" &&
        queryParams.get("roleType") !== null
          ? queryParams.get("roleType")
          : null,
      modifier:
        queryParams.get("modifier") !== "undefined" &&
        queryParams.get("modifier") !== null
          ? queryParams.get("modifier")
          : null,
      levelOfWork:
        queryParams.get("levelOfWork") !== "undefined" &&
        queryParams.get("levelOfWork") !== null
          ? queryParams.get("levelOfWork")
          : null,
      q2:
        queryParams.get("q2") !== "undefined" && queryParams.get("q2") !== null
          ? queryParams.get("q2")
          : null,
      q3:
        queryParams.get("q3") !== "undefined" && queryParams.get("q3") !== null
          ? queryParams.get("q3")
          : null,
      q4:
        queryParams.get("q4") !== "undefined" && queryParams.get("q4") !== null
          ? queryParams.get("q4")
          : null,
      q5:
        queryParams.get("q5") !== "undefined" && queryParams.get("q5") !== null
          ? queryParams.get("q5")
          : null,
      q6:
        queryParams.get("q6") !== "undefined" && queryParams.get("q6") !== null
          ? queryParams.get("q6")
          : null,
      q7:
        queryParams.get("q7") !== "undefined" && queryParams.get("q7") !== null
          ? queryParams.get("q7")
          : null,
      q8:
        queryParams.get("q8") !== "undefined" && queryParams.get("q8") !== null
          ? queryParams.get("q8")
          : null,
      minScore:
        queryParams.get("minScore") !== "undefined" &&
        queryParams.get("minScore") !== null
          ? queryParams.get("minScore")
          : null,
      maxScore:
        queryParams.get("maxScore") !== "undefined" &&
        queryParams.get("maxScore") !== null
          ? queryParams.get("maxScore")
          : null,
      minLvl:
        queryParams.get("minLvl") !== "undefined" &&
        queryParams.get("minLvl") !== null
          ? queryParams.get("minLvl")
          : null,
      maxLvl:
        queryParams.get("maxLvl") !== "undefined" &&
        queryParams.get("maxLvl") !== null
          ? queryParams.get("maxLvl")
          : null,
    };
    setFilters(filtersObj);
    setInitial(false);
    // eslint-disable-next-line
  }, [location.search]);

  useEffect(() => {
    if (!initial) {
      handleGetEvaluations();
    }
    // eslint-disable-next-line
  }, [searchVal, filters, params?.id]);

  useDebounce(
    () => {
      setSearchVal(search);
    },
    [search],
    800
  );

  return (
    <div className={classNames(styles.mainContainer)}>
      <div
        className={classNames(
          "flex items-start gap-3 lg:items-center justify-between flex-col lg:flex-row px-4 py-4"
        )}
      >
        <div className={classNames("flex flex-col items-start")}>
          <h1 className={classNames(styles.tableMainHeading)}>
            Evaluation Results with Version History
          </h1>
          <p className={classNames(styles.tableMainTitle)}>
            Showing Evaluation History for Job
          </p>
        </div>
        <div className={classNames("flex flex-wrap items-center gap-3")}>
          <div className={classNames(styles.searchContainer, "flex")}>
            <Icons.Search className={classNames(styles.searchIconStyle)} />
            <input
              className={classNames(styles.searchInputStyle, "ps-2")}
              value={search}
              placeholder="Search Job Title / Dept"
              onChange={(e) => {
                setSearch(e.target.value);
              }}
            />
          </div>

          <CustomButton
            title="Filter"
            containerStyle={classNames(styles.buttonMain)}
            Icon={Icons.Filter}
            IconDirction="left"
            iconStyle={classNames(styles.buttonIcon)}
            onClick={() => {
              setOpenFilters(!openFilters);
            }}
          />
        </div>
      </div>
      <Draggable disableScroll={evaluations.length === 0 && !loading}>
        <table
          className="table w-full"
          style={{ minWidth: "3627px", margin: "0px" }}
        >
          {selectedColumns?.length === 0 ? (
            <tr className={classNames(styles.stickyHeader)}>
              <td colSpan={6}></td>
              <th
                colSpan={3}
                scope="colgroup"
                className={classNames(styles.mainHead)}
              >
                Knowledge & Skill
              </th>
              <th
                colSpan={2}
                scope="colgroup"
                className={classNames(styles.mainHead)}
              >
                Working Environment
              </th>
              <td colSpan={9}></td>
            </tr>
          ) : null}

          <tr
            style={{ height: "48px" }}
            className={classNames(styles.stickyHeader2)}
          >
            {ColumnHeads.map((column, index) => {
              return (
                <TableHead
                  index={index}
                  key={index}
                  column={column}
                  selectedColumns={selectedColumns}
                  sortingKeys={sortingKeys}
                  handleSorting={handleSorting}
                />
              );
            })}
          </tr>
          <tbody>
            {loading ? (
              <>
                {Array.from(Array(5).keys()).map((_, index) => {
                  return <TableRowLoader key={index} />;
                })}
              </>
            ) : (
              <>
                {evaluations.map((evaluation, index) => {
                  return (
                    <TableRow
                      item={evaluation}
                      key={evaluation?.id}
                      index={index}
                      selectedColumns={selectedColumns}
                      evaluations={evaluations}
                      openDropdown={openDropdown}
                      handleGetEvaluations={handleGetEvaluations}
                      setSelectedItem={setSelectedItem}
                      setOpenDropdown={setOpenDropdown}
                    />
                  );
                })}
              </>
            )}
          </tbody>
        </table>
      </Draggable>
      {evaluations.length === 0 && !loading ? (
        <div className={classNames("my-5")}>
          <NoContentCard
            label1="No Data Found"
            label2={`There is no data available in the "Evaluation Result With Versions History" table`}
          />
        </div>
      ) : null}

      <DownlaodOptionsDropDown
        open={openDropdown}
        setOpen={setOpenDropdown}
        options={options}
        id={`download`}
        data={selectedItem}
      />
      <FilterSideCanvas
        isOpen={openFilters}
        setIsOpen={setOpenFilters}
        selectedColumns={selectedColumns}
        setSelectedColumns={setSelectedColumns}
        routePath={routeConstant.evaluationRecordDetail.path
          .replace(":id", params?.id ? params?.id : "")
          .replace(":org", params?.org ? params?.org : "")}
        parentFilters={filters}
      />
    </div>
  );
};

const TableHead = ({
  index,
  column,
  selectedColumns,
  sortingKeys,
  handleSorting,
}: any) => {
  const id = useId();

  return (
    <th
      className={classNames(
        (index === 0 || index === 1 || index === ColumnHeads.length - 1) &&
          "sticky-col",
        index === 0 && "first-col",
        index === 1 && "second-col",
        index === 0 ? "ps-4" : "ps-2",
        index === ColumnHeads.length - 1 ? "pe-4" : "pe-2",
        styles.tableHead,
        selectedColumns?.length > 0
          ? !selectedColumns.includes(column?.title) &&
              !FixedColumns.includes(column?.title) &&
              "hidden"
          : ""
      )}
      style={index === ColumnHeads.length - 1 ? { right: "0px" } : {}}
    >
      <div
        className={classNames(
          "flex items-center  relative",
          index !== ColumnHeads.length - 1
            ? "justify-between"
            : "justify-center"
        )}
      >
        {column?.title}
        {index !== ColumnHeads.length - 1 ? (
          <div id={`custom-select-head-container-${id}`}>
            {sortingKeys.includes(column?.key) ? (
              <Icons.SortAscending
                className={classNames("cursor-pointer")}
                onClick={() => {
                  handleSorting(column?.key, true);
                }}
              />
            ) : (
              <Icons.SortDescending
                className={classNames("cursor-pointer")}
                onClick={() => {
                  handleSorting(column?.key, false);
                }}
              />
            )}
          </div>
        ) : null}
      </div>
    </th>
  );
};

const TableRow = ({
  item,
  selectedColumns,
  openDropdown,
  setSelectedItem,
  setOpenDropdown,
}: any) => {
  const navigate = useNavigate();

  return (
    <>
      <tr>
        <td
          className={classNames(
            styles.tableContentLabel,
            "ps-4 oe-2 py-3 sticky-col first-col"
          )}
        >
          <Switch toggle={item?.isActive} />
        </td>
        <td
          className={classNames(
            styles.tableContentLabel,
            "ps-4 oe-2 py-3 sticky-col second-col"
          )}
        >
          {item?.jobTitle}
        </td>
        <td
          className={classNames(
            styles.tableContentLabel,
            "px-2 py-3",
            selectedColumns?.length > 0
              ? !selectedColumns.includes("Department") && "hidden"
              : ""
          )}
        >
          {item?.department}
        </td>
        <td
          className={classNames(
            styles.tableContentLabel,
            "px-2 py-3",
            selectedColumns?.length > 0
              ? !selectedColumns.includes("Job Code") && "hidden"
              : ""
          )}
        >
          {item?.jobeCode}
        </td>
        <td
          className={classNames(
            styles.tableContentLabel,
            "px-2 py-3",
            selectedColumns?.length > 0
              ? !selectedColumns.includes("Job Grade") && "hidden"
              : ""
          )}
        >
          {item?.jobGrade ? item?.jobGrade : "N/A"}
        </td>
        <td
          className={classNames(
            styles.tableContentLabel,
            "px-2 py-3",
            selectedColumns?.length > 0
              ? !selectedColumns.includes("Role Type") && "hidden"
              : ""
          )}
        >
          {item?.roleType === JobRole.management
            ? "Manager"
            : "Individual Contributor"}
        </td>
        <td
          className={classNames(
            styles.tableContentLabel,
            "px-2 py-3",
            selectedColumns?.length > 0
              ? !selectedColumns.includes("Level of Work & Modifier") &&
                  "hidden"
              : ""
          )}
        >
          <div className="flex items-center justify-between gap-3 w-full">
            <label>{item?.level_of_work?.short_des}</label>
            <span className={classNames(styles.modifier)}>
              {item?.modifier}
            </span>
          </div>
        </td>
        <td
          className={classNames(
            styles.tableContentLabel,
            "px-2 py-3",
            selectedColumns?.length > 0
              ? !selectedColumns.includes("Institutional Expertise & Skill") &&
                  "hidden"
              : ""
          )}
        >
          {item?.q2?.short_des}
        </td>
        <td
          className={classNames(
            styles.tableContentLabel,
            "px-2 py-3",
            selectedColumns?.length > 0
              ? !selectedColumns.includes("Cultural Impact") && "hidden"
              : ""
          )}
        >
          {item?.q3?.short_des}
        </td>
        <td
          className={classNames(
            styles.tableContentLabel,
            "px-2 py-3",
            selectedColumns?.length > 0
              ? !selectedColumns.includes("Physical Environment") && "hidden"
              : ""
          )}
        >
          {item?.q4?.short_des}
        </td>
        <td
          className={classNames(
            styles.tableContentLabel,
            "px-2 py-3",
            selectedColumns?.length > 0
              ? !selectedColumns.includes("Mental & Emotional Environment") &&
                  "hidden"
              : ""
          )}
        >
          {item?.q5?.short_des}
        </td>
        <td
          className={classNames(
            styles.tableContentLabel,
            "px-2 py-3",
            selectedColumns?.length > 0
              ? !selectedColumns.includes("Application of Knowledge & Skill") &&
                  "hidden"
              : ""
          )}
        >
          {item?.q6?.short_des}
        </td>
        <td
          className={classNames(
            styles.tableContentLabel,
            "px-2 py-3",
            selectedColumns?.length > 0
              ? !selectedColumns.includes("Manual Effort") && "hidden"
              : ""
          )}
        >
          {item?.q7?.short_des}
        </td>
        <td
          className={classNames(
            styles.tableContentLabel,
            "px-2 py-3",
            selectedColumns?.length > 0
              ? !selectedColumns.includes("Outcomes") && "hidden"
              : ""
          )}
        >
          {item?.q8?.short_des}
        </td>
        <td
          className={classNames(
            styles.tableContentLabel,
            styles.highlighted,
            "px-2 py-3"
          )}
        >
          {item?.rasScore}
        </td>
        <td
          className={classNames(
            styles.tableContentLabel,
            styles.highlighted,
            "px-2 py-3"
          )}
        >
          {item?.rasLevel}
        </td>
        <td
          className={classNames(
            styles.tableContentLabel,
            styles.highlighted,
            "px-2 py-3"
          )}
        >
          {item?.shortCode}
        </td>
        <td className={classNames(styles.tableContentLabel, "px-2 py-3")}>
          {item?.evaluated_by?.name ? item?.evaluated_by?.name : "CGP"}
        </td>
        <td className={classNames(styles.tableContentLabel, "px-2 py-3")}>
          {moment(item?.created_at).format("MMM DD, YYYY")}
        </td>
        <td
          className={classNames(
            styles.tableContentLabel,
            "ps-2 pe-2 py-3 sticky-col"
          )}
          style={{ verticalAlign: "middle", textAlign: "center", right: "0px" }}
        >
          <div className={classNames("flex items-center gap-2 justify-center")}>
            {!item?.evaluated_by ? (
              <CustomToolTip label="Edit">
                <div
                  className={classNames(styles.actionContainer)}
                  onClick={() => {
                    navigate(
                      routeConstant.editEvaluationRecord.path.replace(
                        ":id",
                        item?.id
                      )
                    );
                  }}
                >
                  <Icons.Pencil />
                </div>
              </CustomToolTip>
            ) : null}
            <div
              className={classNames(styles.actionContainer)}
              onClick={() => {
                setSelectedItem(item);
                setOpenDropdown(!openDropdown);
              }}
              id={`custom-select-container-${item?.id}`}
            >
              <Icons.VerticalDots />
            </div>
          </div>
        </td>
      </tr>
    </>
  );
};
const TableRowLoader = () => {
  return (
    <>
      <tr>
        <td
          className={classNames(styles.tableContentLabel, "ps-4 pe-2 py-3")}
          style={{ verticalAlign: "middle" }}
        >
          <div className={classNames("flex items-center justify-center")}>
            <SekeletonLoader className={classNames(styles.lineLoader)} />
          </div>
        </td>

        <td className={classNames(styles.tableContentLabel, "px-2 py-3")}>
          <div className={classNames("flex items-center justify-center")}>
            <SekeletonLoader className={classNames(styles.lineLoader)} />
          </div>
        </td>
        <td className={classNames(styles.tableContentLabel, "px-2 py-3")}>
          <div className={classNames("flex items-center justify-center")}>
            <SekeletonLoader className={classNames(styles.lineLoader)} />
          </div>
        </td>
        <td className={classNames(styles.tableContentLabel, "px-2 py-3")}>
          <div className={classNames("flex items-center justify-center")}>
            <SekeletonLoader className={classNames(styles.lineLoader)} />
          </div>
        </td>
        <td className={classNames(styles.tableContentLabel, "px-2 py-3")}>
          <div className={classNames("flex items-center justify-center")}>
            <SekeletonLoader className={classNames(styles.lineLoader)} />
          </div>
        </td>
        <td className={classNames(styles.tableContentLabel, "px-2 py-3")}>
          <div className={classNames("flex items-center justify-center")}>
            <SekeletonLoader className={classNames(styles.lineLoader)} />
          </div>
        </td>
        <td className={classNames(styles.tableContentLabel, "px-2 py-3")}>
          <div className={classNames("flex items-center justify-center")}>
            <SekeletonLoader className={classNames(styles.lineLoader)} />
          </div>
        </td>
        <td className={classNames(styles.tableContentLabel, "px-2 py-3")}>
          <div className={classNames("flex items-center justify-center")}>
            <SekeletonLoader className={classNames(styles.lineLoader)} />
          </div>
        </td>
        <td className={classNames(styles.tableContentLabel, "px-2 py-3")}>
          <div className={classNames("flex items-center justify-center")}>
            <SekeletonLoader className={classNames(styles.lineLoader)} />
          </div>
        </td>
        <td className={classNames(styles.tableContentLabel, "px-2 py-3")}>
          <div className={classNames("flex items-center justify-center")}>
            <SekeletonLoader className={classNames(styles.lineLoader)} />
          </div>
        </td>
        <td className={classNames(styles.tableContentLabel, "px-2 py-3")}>
          <div className={classNames("flex items-center justify-center")}>
            <SekeletonLoader className={classNames(styles.lineLoader)} />
          </div>
        </td>
        <td className={classNames(styles.tableContentLabel, "px-2 py-3")}>
          <div className={classNames("flex items-center justify-center")}>
            <SekeletonLoader className={classNames(styles.lineLoader)} />
          </div>
        </td>
        <td className={classNames(styles.tableContentLabel, "px-2 py-3")}>
          <div className={classNames("flex items-center justify-center")}>
            <SekeletonLoader className={classNames(styles.lineLoader)} />
          </div>
        </td>
        <td className={classNames(styles.tableContentLabel, "px-2 py-3")}>
          <div className={classNames("flex items-center justify-center")}>
            <SekeletonLoader className={classNames(styles.lineLoader)} />
          </div>
        </td>
        <td className={classNames(styles.tableContentLabel, "px-2 py-3")}>
          <div className={classNames("flex items-center justify-center")}>
            <SekeletonLoader className={classNames(styles.lineLoader)} />
          </div>
        </td>
        <td className={classNames(styles.tableContentLabel, "px-2 py-3")}>
          <div className={classNames("flex items-center justify-center")}>
            <SekeletonLoader className={classNames(styles.lineLoader)} />
          </div>
        </td>
        <td className={classNames(styles.tableContentLabel, "px-2 py-3")}>
          <div className={classNames("flex items-center justify-center")}>
            <SekeletonLoader className={classNames(styles.lineLoader)} />
          </div>
        </td>
        <td className={classNames(styles.tableContentLabel, "px-2 py-3")}>
          <div className={classNames("flex items-center justify-center")}>
            <SekeletonLoader className={classNames(styles.lineLoader)} />
          </div>
        </td>
        <td
          className={classNames(styles.tableContentLabel, "ps-2 pe-4 py-3")}
          style={{ verticalAlign: "middle" }}
        >
          <div className={classNames("flex items-center justify-center gap-2")}>
            <SekeletonLoader
              className={classNames(styles.actionContainerLoader)}
            />
            <SekeletonLoader
              className={classNames(styles.actionContainerLoader)}
            />
            <SekeletonLoader
              className={classNames(styles.actionContainerLoader)}
            />
          </div>
        </td>
      </tr>
    </>
  );
};

export default EvaluationDetail;
